import {
  DASHBOARD,
  DASHBOARD_ERROR_WELD_LOG_STATICS,
  DASHBOARD_FORM_STATUS_STATICS,
  DASHBOARD_INSPECTION_BREAKDOWN,
  DASHBOARD_PROJECT_STATICS,
  DASHBOARD_WELD_STATICS,
  DASHBOPARD_WELD_LOG_REJECTION_COUNT,
  MATERIAL_TOOL_CLASSIFICATION_COUNT,
  MATERIAL_TOOL_COUNT,
  MATERIAL_TOOL_LOCATION_COUNT,
  OPERATOR_SUMMARY,
  OTHER_INSPECTION_TYPE,
  WELD_COUNT_BY_WELDER,
  WELD_TOTALS_BY_SYSTEM,
  WELDER_SUMMARY,
} from "../../../components/common/api";
import { axiosInstance } from "../../../components/common/interceptor";
import {
  fetchDashboardFailure,
  fetchDashboardStart,
  fetchDashboardSuccess,
  fetchProjectDashboardStaticsStart,
  fetchProjectDashboardStaticsSuccess,
  fetchProjectDashboardStaticsFailure,
  fetchProjectDashboardWeldStaticsStart,
  fetchProjectDashboardWeldStaticsSuccess,
  fetchProjectDashboardWeldStaticsFailure,
  fetchProjectDashboardFormStatusStart,
  fetchProjectDashboardFormStatusSuccess,
  fetchProjectDashboardFormStatusFailure,
  fetchErrorWeldLogStart,
  fetchErrorWeldLogSuccess,
  fetchErrorWeldLogFailure,
  fetchDashboardRejectionBreakStart,
  fetchDashboardRejectionBreakSuccess,
  fetchDashboardRejectionBreakFailure,
  fetchDashboardWeldLogRejectionBreakStart,
  fetchDashboardWeldLogRejectionBreakSuccess,
  fetchDashboardWeldLogRejectionBreakFailure,
  fetchDashboardWeldCountBWelderStart,
  fetchDashboardWeldCountBWelderSuccess,
  fetchDashboardWeldCountBWelderFailure,
  fetchWeldTotalBySystemStart,
  fetchWeldTotalBySystemSuccess,
  fetchWeldTotalBySystemFailure,
  fetchMaterialToolClassificationStart,
  fetchMaterialToolClassificationSuccess,
  fetchMaterialToolClassificationFailure,
  fetchMaterialToolLocationStart,
  fetchMaterialToolLocationFailure,
  fetchMaterialToolLocationSuccess,
  fetchMaterialToolStart,
  fetchMaterialToolSuccess,
  fetchMaterialToolFailure,
  fetchOperatorSummaryStart,
  fetchOperatorSummarySuccess,
  fetchOperatorSummaryFailure,
  fetchDashboardWeldLogOtherStart,
  fetchDashboardWeldLogOtherSuccess,
  fetchDashboardWeldLogOtherFailure,
  fetchOperatorWelderStart,
  fetchOperatorWelderSuccess,
  fetchOperatorWelderFailure,
} from "../../reducer/DashboardReducer/DashboardReducer";

let isFetching = false;
let isFetchingProject = false;
let isFetchingWeldProject = false;
let isFetchingFormStatusProject = false;
let isFetchingErrorWeldLog = false;
let dashboardInspectionBreakdown = false;
let isdashboardWeldLogRejectionCount = false;
let isdashboardWeldTotalBySystem = false;
let isFetchingMaterialToolLocation = false;
let isFetchingMaterialToolClassification = false;
let isFetchingMaterialTool = false;
let isdashboardWeldLogOtherCount = false;

export const GetDashboardDetails = () => async (dispatch) => {
  if (isFetching) return;
  isFetching = true;
  dispatch(fetchDashboardStart());
  try {
    const response = await axiosInstance.get(`${DASHBOARD}`);
    if (response.status !== 200) {
      throw new Error("Failed to fetch dashboard details.");
    }
    dispatch(fetchDashboardSuccess(response?.data?.result));
  } catch (error) {
    console.error("Error fetching dashboard details:", error);
    dispatch(
      fetchDashboardFailure(error.message || "An unexpected error occurred")
    );
  } finally {
    isFetching = false;
  }
};

// .................... Get Dashboard Project Statics ........................

export const GetProjectStatics =
  (dashboardProjectId, selectedDateRange, form_name, onSuccess, onError) =>
  async (dispatch) => {
    if (isFetchingProject) return;
    isFetchingProject = true;
    if (!dashboardProjectId) {
      onError?.("Please select a valid project");
      return;
    }
    dispatch(fetchProjectDashboardStaticsStart());
    try {
      const [start_date, end_date] = selectedDateRange.split(":");
      const response = await axiosInstance.get(`${DASHBOARD_PROJECT_STATICS}`, {
        params: {
          project_id: dashboardProjectId,
          start_date,
          end_date,
          form_name,
        },
      });

      if (response.status !== 200) {
        throw new Error("Failed to fetch project statistics.");
      }
      dispatch(fetchProjectDashboardStaticsSuccess(response?.data?.result));
      onSuccess?.();
    } catch (error) {
      console.error("Error fetching project statistics:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred";
      dispatch(fetchProjectDashboardStaticsFailure(errorMessage));
      onError?.(errorMessage);
    } finally {
      isFetchingProject = false;
    }
  };

// .................... Get Dashboard Weld Statics ........................

export const GetDashboardWeldStatics =
  (dashboardsProjectId, selectedDateRange, form_name, onSuccess, onError) =>
  async (dispatch) => {
    if (isFetchingWeldProject) return;
    isFetchingWeldProject = true;
    if (!dashboardsProjectId) {
      onError?.("Please select a valid project");
      return;
    }
    dispatch(fetchProjectDashboardWeldStaticsStart());
    try {
      const [start_date, end_date] = selectedDateRange.split(":");
      const response = await axiosInstance.get(`${DASHBOARD_WELD_STATICS}`, {
        params: {
          project_id: dashboardsProjectId,
          start_date,
          end_date,
          form_name,
        },
      });
      if (response.status !== 200) {
        throw new Error("Failed to fetch project statistics.");
      }
      dispatch(fetchProjectDashboardWeldStaticsSuccess(response?.data));
      onSuccess?.();
    } catch (error) {
      console.error("Error fetching project statistics:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred";
      dispatch(fetchProjectDashboardWeldStaticsFailure(errorMessage));
      onError?.(errorMessage);
    } finally {
      isFetchingWeldProject = false;
    }
  };

// .................... Get Dashboard Form Status Statics ........................

export const GetDashboardFormStatusStatics =
  (dashboardsProjectId,selectedDateRange, onSuccess, onError) => async (dispatch) => {
    if (isFetchingFormStatusProject) return;
    isFetchingFormStatusProject = true;
    if (!dashboardsProjectId) {
      onError?.("Please select a valid project");
      return;
    }
    dispatch(fetchProjectDashboardFormStatusStart());
    try {
      const [start_date, end_date] = selectedDateRange.split(":");
      const response = await axiosInstance.get(
        `${DASHBOARD_FORM_STATUS_STATICS}`,
        {
          params: { project_id: dashboardsProjectId, start_date, end_date },
        }
      );
      if (response.status !== 200) {
        throw new Error("Failed to fetch project statistics.");
      }
      dispatch(fetchProjectDashboardFormStatusSuccess(response?.data));
      onSuccess?.();
    } catch (error) {
      console.error("Error fetching project statistics:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred";
      dispatch(fetchProjectDashboardFormStatusFailure(errorMessage));
      onError?.(errorMessage);
    } finally {
      isFetchingFormStatusProject = false;
    }
  };

// .......................... Get dasboard Inspection error weld logs statics ....................

export const GetDashboardErrorWeldDetails =
  (dashboardsProjectId) => async (dispatch) => {
    if (isFetchingErrorWeldLog) return;
    isFetchingErrorWeldLog = true;
    dispatch(fetchErrorWeldLogStart());
    try {
      const response = await axiosInstance.get(
        `${DASHBOARD_ERROR_WELD_LOG_STATICS}`,
        {
          params: { project_id: dashboardsProjectId },
        }
      );
      if (response.status !== 200) {
        throw new Error("Failed to fetch dashboard details.");
      }
      dispatch(fetchErrorWeldLogSuccess(response?.data?.result));
    } catch (error) {
      console.error("Error fetching dashboard details:", error);
      dispatch(
        fetchErrorWeldLogFailure(
          error.message || "An unexpected error occurred"
        )
      );
    } finally {
      isFetchingErrorWeldLog = false;
    }
  };

// .................. Dashboard Inspection Breakdown .........................

export const GetDashboardInspectionBreakdownDetails =
  (projectId, selectedDateRange, onSuccess, onError) => async (dispatch) => {
    if (dashboardInspectionBreakdown) return;
    dashboardInspectionBreakdown = true;
    if (!projectId) {
      onError?.("Please select a valid project");
      dashboardInspectionBreakdown = false;
      return;
    }
    if (!selectedDateRange || !selectedDateRange.includes(":")) {
      onError?.("Invalid date range");
      dashboardInspectionBreakdown = false;
      return;
    }
    dispatch(fetchDashboardRejectionBreakStart());
    const [startDate, endDate] = selectedDateRange.split(":");
    try {
      const response = await axiosInstance.get(DASHBOARD_INSPECTION_BREAKDOWN, {
        params: {
          project_id: projectId,
          start_date: startDate,
          end_date: endDate,
        },
      });
      if (response.status !== 200) {
        throw new Error("Failed to fetch dashboard details.");
      }
      dispatch(fetchDashboardRejectionBreakSuccess(response?.data?.result));
      onSuccess?.();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred";
      console.error("Error fetching project statistics:", error);
      dispatch(fetchDashboardRejectionBreakFailure(errorMessage));
      onError?.(errorMessage);
    } finally {
      dashboardInspectionBreakdown = false;
    }
  };

// .................. Dashboard Weldlog Rejection Count .........................

export const GetDashboardWeldLogRejectCountDetails =
  (projectId, selectedDateRange, onSuccess, onError) => async (dispatch) => {
    if (isdashboardWeldLogRejectionCount) return;
    isdashboardWeldLogRejectionCount = true;
    if (!projectId) {
      onError?.("Please select a valid project");
      isdashboardWeldLogRejectionCount = false;
      return;
    }
    if (!selectedDateRange || !selectedDateRange.includes(":")) {
      onError?.("Invalid date range");
      isdashboardWeldLogRejectionCount = false;
      return;
    }
    dispatch(fetchDashboardWeldLogRejectionBreakStart());
    const [startDate, endDate] = selectedDateRange.split(":");
    try {
      const response = await axiosInstance.get(
        DASHBOPARD_WELD_LOG_REJECTION_COUNT,
        {
          params: {
            project_id: projectId,
            start_date: startDate,
            end_date: endDate,
          },
        }
      );
      if (response.status !== 200) {
        throw new Error("Failed to fetch dashboard details.");
      }
      dispatch(
        fetchDashboardWeldLogRejectionBreakSuccess(response?.data?.result)
      );
      onSuccess?.();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred";
      console.error("Error fetching project statistics:", error);
      dispatch(fetchDashboardWeldLogRejectionBreakFailure(errorMessage));
      onError?.(errorMessage);
    } finally {
      isdashboardWeldLogRejectionCount = false;
    }
  };

// .................. Dashboard Weldlog Rejection Count .........................

let isdashboardWeldCountBWelder = false;
export const GetDashboardWeldCountByWelderDetails =
  (projectId, formName, selectedDateRange, onSuccess, onError) =>
  async (dispatch) => {
    if (isdashboardWeldCountBWelder) return;
    isdashboardWeldCountBWelder = true;
    if (!projectId) {
      onError?.("Please select a valid project");
      isdashboardWeldCountBWelder = false;
      return;
    }
    if (!selectedDateRange || !selectedDateRange.includes(":")) {
      onError?.("Invalid date range");
      isdashboardWeldCountBWelder = false;
      return;
    }
    dispatch(fetchDashboardWeldCountBWelderStart());
    const [startDate, endDate] = selectedDateRange.split(":");
    try {
      const response = await axiosInstance.get(WELD_COUNT_BY_WELDER, {
        params: {
          project_id: projectId,
          form_name: formName,
          start_date: startDate,
          end_date: endDate,
        },
      });
      if (response.status !== 200) {
        throw new Error("Failed to fetch dashboard details.");
      }
      dispatch(fetchDashboardWeldCountBWelderSuccess(response?.data?.result));
      onSuccess?.();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred";
      console.error("Error fetching project statistics:", error);
      dispatch(fetchDashboardWeldCountBWelderFailure(errorMessage));
      onError?.(errorMessage);
    } finally {
      isdashboardWeldCountBWelder = false;
    }
  };

// .................... Weld totals by System data .........................

export const GetDashboardWeldTostaSystemStatics =
  (projectId, selectedDateRange, onSuccess, onError) => async (dispatch) => {
    if (isdashboardWeldTotalBySystem) return;
    isdashboardWeldTotalBySystem = true;
    if (!projectId) {
      onError?.("Please select a valid project");
      isdashboardWeldCountBWelder = false;
      return;
    }
    if (!selectedDateRange || !selectedDateRange.includes(":")) {
      onError?.("Invalid date range");
      isdashboardWeldTotalBySystem = false;
      return;
    }
    dispatch(fetchWeldTotalBySystemStart());
    const [startDate, endDate] = selectedDateRange.split(":");
    try {
      const response = await axiosInstance.get(WELD_TOTALS_BY_SYSTEM, {
        params: {
          project_id: projectId,
          start_date: startDate,
          end_date: endDate,
        },
      });
      if (response.status !== 200) {
        throw new Error("Failed to fetch dashboard details.");
      }
      dispatch(fetchWeldTotalBySystemSuccess(response?.data));
      onSuccess?.();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred";
      console.error("Error fetching project statistics:", error);
      dispatch(fetchWeldTotalBySystemFailure(errorMessage));
      onError?.(errorMessage);
    } finally {
      isdashboardWeldTotalBySystem = false;
    }
  };

// .......................... Get dasboard Material tool location statics ....................

export const GetDashboardMaterialToolLocation =
  (projectId, selectedDateRange, onSuccess, onError) => async (dispatch) => {
    if (isFetchingMaterialToolLocation) return;
    isFetchingMaterialToolLocation = true;
    if (!projectId) {
      onError?.("Please select a valid project");
      isFetchingMaterialToolLocation = false;
      return;
    }
    if (!selectedDateRange || !selectedDateRange.includes(":")) {
      onError?.("Invalid date range");
      isFetchingMaterialToolLocation = false;
      return;
    }
    dispatch(fetchMaterialToolLocationStart());
    const [startDate, endDate] = selectedDateRange.split(":");
    try {
      const response = await axiosInstance.get(MATERIAL_TOOL_LOCATION_COUNT, {
        params: {
          project_id: projectId,
          start_date: startDate,
          end_date: endDate,
        },
      });
      if (response.status !== 200) {
        throw new Error("Failed to fetch dashboard details.");
      }
      dispatch(fetchMaterialToolLocationSuccess(response?.data?.result));
      onSuccess?.();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred";
      console.error("Error fetching project statistics:", error);
      dispatch(fetchMaterialToolLocationFailure(errorMessage));
      onError?.(errorMessage);
    } finally {
      isFetchingMaterialToolLocation = false;
    }
  };

// .......................... Get dasboard Material tool classification statics ....................

export const GetDashboardMaterialToolClassification =
  (projectId, selectedDateRange, onSuccess, onError) => async (dispatch) => {
    if (isFetchingMaterialToolClassification) return;
    isFetchingMaterialToolClassification = true;
    if (!projectId) {
      onError?.("Please select a valid project");
      isFetchingMaterialToolClassification = false;
      return;
    }
    if (!selectedDateRange || !selectedDateRange.includes(":")) {
      onError?.("Invalid date range");
      isFetchingMaterialToolClassification = false;
      return;
    }
    dispatch(fetchMaterialToolClassificationStart());
    const [startDate, endDate] = selectedDateRange.split(":");
    try {
      const response = await axiosInstance.get(
        MATERIAL_TOOL_CLASSIFICATION_COUNT,
        {
          params: {
            project_id: projectId,
            start_date: startDate,
            end_date: endDate,
          },
        }
      );
      if (response.status !== 200) {
        throw new Error("Failed to fetch dashboard details.");
      }
      dispatch(fetchMaterialToolClassificationSuccess(response?.data?.result));
      onSuccess?.();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred";
      console.error("Error fetching project statistics:", error);
      dispatch(fetchMaterialToolClassificationFailure(errorMessage));
      onError?.(errorMessage);
    } finally {
      isFetchingMaterialToolClassification = false;
    }
  };

// .................... Get Material Tool Statics ........................

export const GetMaterialToolStatics =
  (projectId, classification, locatin, selectedDateRange, onSuccess, onError) =>
  async (dispatch) => {
    if (isFetchingMaterialTool) return;
    isFetchingMaterialTool = true;
    if (!projectId) {
      onError?.("Please select a valid project");
      return;
    }
    dispatch(fetchMaterialToolStart());
    try {
      const [start_date, end_date] = selectedDateRange.split(":");
      const response = await axiosInstance.get(`${MATERIAL_TOOL_COUNT}`, {
        params: {
          project_id: projectId,
          classification,
          location: locatin,
          start_date,
          end_date,
        },
      });
      if (response.status !== 200) {
        throw new Error("Failed to fetch project statistics.");
      }
      dispatch(fetchMaterialToolSuccess(response?.data?.result?.data));
      onSuccess?.();
    } catch (error) {
      console.error("Error fetching project statistics:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred";
      dispatch(fetchMaterialToolFailure(errorMessage));
      onError?.(errorMessage);
    } finally {
      isFetchingMaterialTool = false;
    }
  };

// .................... Get Operator Summary Statics ........................

let isdashboardOperatorSummary = false;
export const GetDashboardOperatorSummary =
  (dashboardProjectId, selectedDateRange, form_name, onSuccess, onError) =>
  async (dispatch) => {
    if (isdashboardOperatorSummary) return;
    isdashboardOperatorSummary = true;
    if (!dashboardProjectId) {
      onError?.("Please select a valid project");
      isdashboardOperatorSummary = false;
      return;
    }
    if (!selectedDateRange || !selectedDateRange.includes(":")) {
      onError?.("Invalid date range");
      isdashboardOperatorSummary = false;
      return;
    }
    dispatch(fetchOperatorSummaryStart());
   const [start_date, end_date] = selectedDateRange.split(":");
    try {
      const response = await axiosInstance.get(OPERATOR_SUMMARY, {
        params: {
          project_id: dashboardProjectId,
          start_date,
          end_date,
          form_name,
        },
      });
      if (response.status !== 200) {
        throw new Error("Failed to fetch dashboard details.");
      }
      dispatch(fetchOperatorSummarySuccess(response?.data?.result));
      onSuccess?.();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred";
      console.error("Error fetching project statistics:", error);
      dispatch(fetchOperatorSummaryFailure(errorMessage));
      onError?.(errorMessage);
    } finally {
      isdashboardOperatorSummary = false;
    }
  };


// ............................. Other Inspection type ...........................

export const GetDashboardWeldLogOtherCountDetails =
  (projectId, selectedDateRange, onSuccess, onError) => async (dispatch) => {
    if (isdashboardWeldLogOtherCount) return;
    isdashboardWeldLogOtherCount = true;
    if (!projectId) {
      onError?.("Please select a valid project");
      isdashboardWeldLogOtherCount = false;
      return;
    }
    if (!selectedDateRange || !selectedDateRange.includes(":")) {
      onError?.("Invalid date range");
      isdashboardWeldLogOtherCount = false;
      return;
    }
    dispatch(fetchDashboardWeldLogOtherStart());
    const [startDate, endDate] = selectedDateRange.split(":");
    try {
      const response = await axiosInstance.get(OTHER_INSPECTION_TYPE, {
        params: {
          project_id: projectId,
          start_date: startDate,
          end_date: endDate,
        },
      });
      if (response.status !== 200) {
        throw new Error("Failed to fetch dashboard details.");
      }
      dispatch(fetchDashboardWeldLogOtherSuccess(response?.data?.result));
      onSuccess?.();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message || "An unexpected error occurred";
      dispatch(fetchDashboardWeldLogOtherFailure(errorMessage));
      onError?.(errorMessage);
    } finally {
      isdashboardWeldLogOtherCount = false;
    }
  };


// .................... Get Welder Summary Statics ........................

let isdashboardWelderSummary = false;
export const GetDashboardWelderSummary =
  (dashboardProjectId, selectedDateRange, form_name, onSuccess, onError) =>
  async (dispatch) => {
    if (isdashboardWelderSummary) return;
    isdashboardWelderSummary = true;
    if (!dashboardProjectId) {
      onError?.("Please select a valid project");
      isdashboardWelderSummary = false;
      return;
    }
    if (!selectedDateRange || !selectedDateRange.includes(":")) {
      onError?.("Invalid date range");
      isdashboardWelderSummary = false;
      return;
    }
    dispatch(fetchOperatorWelderStart());
    const [start_date, end_date] = selectedDateRange.split(":");
    try {
      const response = await axiosInstance.get(WELDER_SUMMARY, {
        params: {
          project_id: dashboardProjectId,
          start_date,
          end_date,
          form_name,
        },
      });
      if (response.status !== 200) {
        throw new Error("Failed to fetch dashboard details.");
      }
      dispatch(fetchOperatorWelderSuccess(response?.data?.result));
      onSuccess?.();
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unexpected error occurred";
      console.error("Error fetching project statistics:", error);
      dispatch(fetchOperatorWelderFailure(errorMessage));
      onError?.(errorMessage);
    } finally {
      isdashboardWelderSummary = false;
    }
  };